import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { PayPalButton } from 'react-paypal-button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { sendToGoogleSheet, sendEmailNotification, sendThankyouEmail } from '../functions/api_calls'
import { CLIENT_ID } from '../functions/constants'

const TreeFormStyle = styled.div`
  margin: 10px 0px 0px 0px;
  display: flex;
  flex-direction: column;
  align-items: center;

  form {
    margin-bottom: 0;
    display: flex;
    justify-content: center;
  }
`

const Trees = styled.div`
`

const TreeForm = (props) => {
  const [treeCount, setTreeCount] = useState('10');
  const [paymentStatus, setPaymentStatus] = useState(false);
  const [paymentDetails, setPaymentDetails] = useState({});
  const [donationType, setDonationType] = useState('tree');

  useEffect(() => {
    if (document.querySelector('#treeInput')) {
      document.querySelector('#treeInput').defaultValue = '10';
    }
  })
  
  
  const paypalOptions = {
    clientId: CLIENT_ID,
    intent: 'capture',
    currency: 'EUR',
  }
  
  const buttonStyles = {
    layout: 'vertical',
    shape: 'rect',
    tagline: false,
    color: 'silver'
  }

  const handleChange = (e) => {
    e.persist();
    const numOfTrees = e.target.value;
    setTreeCount(numOfTrees);
  }

  const processPaymentDetails = (paymentData) => {
    setPaymentStatus(true);
    console.log("Payment Info:");
    console.log(paymentData);

    setPaymentDetails({
      email: paymentData.payer.email_address,
      name: `${paymentData.payer.name.given_name} ${paymentData.payer.name.surname}`,
      trees: paymentData.purchase_units[0].amount.value,
    });

    try {
      sendEmailNotification(paymentData, donationType);
    } catch(err) {
      console.log(err);
    }

    try {
      sendThankyouEmail(paymentData, donationType);
    } catch(err) {
      console.log(err);
    }

    try {
      sendToGoogleSheet(paymentData, donationType);
    } catch(err) {
      console.log(err);
    }
  }

  if (!paymentStatus) {
    return (
      <TreeFormStyle>
        <form>
          <div className="field has-addons">
            <p className="control">
              <span className="button is-static">
                I want to plant:
              </span>
            </p>
            <p className="control">
              <input className="input" id='treeInput' type="number" placeholder='10' onChange={handleChange} />
            </p>
            <p className="control">
              <a className="button is-static">
                trees!
              </a>
            </p>
          </div>
        </form>
        <Trees>
          {treeCount === '' || treeCount < 1 ? '' :
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
              <h1>{treeCount} tree{ treeCount === '1' ? '' : 's' } <span className='thin'>- €{treeCount}</span></h1>
              <div>
                <PayPalButton
                  paypalOptions={paypalOptions}
                  buttonStyles={buttonStyles}
                  amount={treeCount}
                  purchaseUnits={[{"description": "Tree Donation"}]}
                  onPaymentSuccess={(data) => processPaymentDetails(data)}    
                  onPaymentError={(msg) => console.log(msg)}
                  onPaymentCancel={(data) => console.log(data)}  
                />
              </div>
            </div>
          }
          
        </Trees>
      </TreeFormStyle>
    )
  } else if (paymentStatus) {
    return (
      <TreeFormStyle>
        <span className='can-green' style={{fontSize: '4em'}}><FontAwesomeIcon icon={faCheck} /></span>
        <h3>Thank you for your donation, </h3>
        <h3 style={{marginTop: '0px'}} className='can-green'>{paymentDetails.name || 'guest'}</h3>
        <p style={{textAlign: 'center'}}>
          With your support, we'll be planting 
          <strong> {parseInt(paymentDetails.trees)} tree{ parseInt(paymentDetails.trees) == '1' ? '' : 's' }</strong>!
          A confirmation email has been sent to {paymentDetails.email}.
        </p>
      </TreeFormStyle>
    )
  }
}

export default TreeForm